import React, {useState, useEffect} from 'react';
import NavbarSecond from "../../components/ui/NavbarSecond";
import {Info} from "../../components/layout/Interface";
import {getNumberGamesPs4, getNumberGamesPs5, getNumberGamesSwitch, getGamesPs4, getGamesPs4Offer, getGamesStock} from "../Queries/getInfo";
import {getTotalMoney} from "../Queries/getResult";
import Spinner from "../ui/Spinner";

const Home = () => {
    const [numberGames, setNumberGames] = useState({
        games: 0,
        totalPrice: 0,
        gamesOffer: 0,
        gamesStock: 0
    })
    const [change, setChange] = useState(true);
    const {games, totalPrice, gamesOffer, gamesStock} = numberGames;

    const getInfo = async () => {
        const result = await getNumberGamesPs4() + await getNumberGamesPs5() + await getNumberGamesSwitch()
        const totalGames = await getGamesPs4();
        const totalMoney = getTotalMoney(totalGames);
        const gamesOfferResult = await getGamesPs4Offer();
        const gamesNumberStock = await getGamesStock();
        setChange(false);
        setNumberGames({
            games: result,
            totalPrice: totalMoney,
            gamesOffer: gamesOfferResult.length,
            gamesStock: gamesNumberStock.length
        });

    }

    useEffect(() => {
        // let unmounted = false;
        getInfo();
        // return () => { unmounted = true };
    }, []);
   

    return (
        <div className = "bg-home">
            <div className = "container p-1">
                <h1 className = "title white">Información de los Productos</h1>
                <div className="column-2 mt-5">
                    <div className="categories">
                        <NavbarSecond />
                    </div>
                    <div className="products mt-5">
                        <h2 className = "title white">Información de ventas</h2>
                        {change ?
                            (   
                                <div className="spinner">
                                    <Spinner className = "white" />
                                </div>
                            )
                            : 
                            (   
                                <>
                                <Info>Juegos registrados: {games} </Info>
                                <Info>Valor neto de todos los juegos registrados: S/ {totalPrice} soles</Info>
                                <Info>Juegos en oferta: {gamesOffer} </Info>
                                <Info>Juegos en stock: {gamesStock} </Info>
                            </>
                        )
                    }
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Home;